export const zoneInfo =
{
    "tunifyVersion": "4,3"
}